import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChecklistPlaceholderIcon = createIcon({
    viewBox: '0 0 76 62',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M7 2v14h14V2H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM7 24v14h14V24H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24a2 2 0 0 1 2-2zM7 46v14h14V46H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V46a2 2 0 0 1 2-2z'
            />
            <Rect fill='currentColor' width={40} height={2} x={31} y={8} rx={1} />
            <Rect fill='currentColor' width={40} height={2} x={31} y={30} rx={1} />
            <Rect fill='currentColor' width={40} height={2} x={31} y={52} rx={1} />
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M13.531 12.345L10 9.6l1.149-1.481 2.134 1.655L16.589 6 18 7.233zM13.531 34.345L10 31.6l1.149-1.481 2.134 1.655L16.589 28 18 29.233zM13.531 56.345L10 53.6l1.149-1.481 2.134 1.655L16.589 50 18 51.233z'
            />
        </>
    ),
})

ChecklistPlaceholderIcon.displayName = 'ChecklistPlaceholderIcon'
